export default "__VITE_ASSET__BwpQjRND__"